import CompensateIcon from '@carbon/shared/components/CompensateIcon'

export default CompensateIcon
